import { Request } from '~src/httpClient/serverApi/requests/Request';

import CustomDomainHttpClient from '../CustomDomainHttpClient';
import { CustomDomainSettingResponse, DeleteCustomDomainSettingRequest } from '../types/CustomDomainTypes';
import { headers } from './GetCustomDomainRequest';

export class DeleteCustomDomainRequest extends Request<DeleteCustomDomainSettingRequest,  CustomDomainSettingResponse> {
    constructor(params: DeleteCustomDomainSettingRequest) {
      super('DELETE', params, headers);
    }
}

export function deleteCustomDomainSetting(siteLuid: string): Promise<CustomDomainSettingResponse> {
    return CustomDomainHttpClient.requestDelete(new DeleteCustomDomainRequest({site_luid: siteLuid}));
}